import React, { useEffect, useState } from 'react';
import '../../css/style.css'
import Modal from './Modal'; 


const SlidingMenu = (props) => {
    useEffect(() => {
        if (props.isOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = ''; 
        }
        return () => {
            document.body.style.overflow = ''; 
        };
    }, [props.isOpen]);

    const [isModalOpen, setIsModalOpen] = useState(false);
    
        const handleOpenModal = () => {
            setIsModalOpen(true);
        };
    
        const handleCloseModal = () => {
            setIsModalOpen(false);
        };

    return (
        <div className={`fixed inset-0 bg-black bg-opacity-75 z-50 transition-opacity duration-700 ${props.isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
            <div className={`bg-white w-full h-full shadow-lg  transform transition-transform duration-700 ${props.isOpen ? 'translate-x-0' : 'translate-x-full'}`}>
                <div className='bg-[#EFF0F2] w-[95%] m-auto p-4 flex justify-between rounded-bl-lg rounded-br-lg'>

                    {/* ЛОГО */}

                    <div className="mainBlock__top-menu-logo">
                        <a href={props.data.logo[1].src}>
                            <img 
                                src={props.data.logo[1].image} 
                                alt={props.data.logo[1].alt}
                                className="w-[140px] h-auto sm:w-auto" 
                            />
                        </a>
                    </div>

                    {/*  */}

                    <div className="flex items-center">
                        <div className="mainBlock__top-buttons-phone hidden lg:flex items-center gap-6">
                        <a href="#" className={` flex items-center`}
                        style={{
                            color: props.data.colors[0].colorBlack,
                        }}>
                            <span className="redKrug"></span> {props.data.phone[0].number}
                        </a>
                        <button onClick={handleOpenModal} className={`btn  duration-300`}
                        style={{
                            backgroundColor: props.data.colors[0].colorRed,
                            color: props.data.colors[0].colorWhite
                        }}>Перезвонить</button>
                        <Modal data={props.data} isOpen={isModalOpen} onClose={handleCloseModal} />
                    </div>
                        {
                            props.authorized ? (
                                <div className='sm:flex hidden'>
                                    <div className="vertical-line mx-4 h-6 bg-gray-400 hidden lg:block"></div>
                                    <div className="burger-menu">
                                        <a href={props.data.userAva[0].link}><img src={props.data.userAva[0].image}/></a>
                                    </div>
                                </div>
                            ) : 
                            <div className='sm:flex hidden items-center '>
                                <div className="vertical-line mx-4 h-6 bg-gray-400 hidden lg:block"></div>
        
                                <div className="flex gap-2">
                                    <a href='/login' className={`border-solid border-[1px] bg-[transparent] transition-colors duration-300 px-6 py-2 rounded-[50px]`}
                                    style={{
                                        color: props.data.colors[0].colorGray,
                                        borderColor: props.data.colors[0].colorGrey
                                        }}>
                                        {props.data.authButtons[0].text}
                                    </a>
                                    <a href='/registration' className={` transition-colors duration-300 px-6 py-2 rounded-[50px]`}
                                    style={{
                                        backgroundColor: props.data.colors[0].colorBlack,
                                        color: props.data.colors[0].colorWhite
                                    }}>
                                    {props.data.authButtons[1].text}
                                    </a>
                                </div>
                            </div>
                        }


                        <div className="burger-menu ml-[20px]">
                            <button 
                                className={`w-10 h-10 flex justify-center items-center`}
                                onClick={props.onClose}>
                                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M32.3586 9.99765L30.0016 7.64062L20.0016 17.6406L10.0016 7.64062L7.64453 9.99765L17.6445 19.9976L7.64453 29.9976L10.0016 32.3547L20.0016 22.3547L30.0016 32.3547L32.3586 29.9976L22.3586 19.9976L32.3586 9.99765Z" fill="#1F2225"/>
</svg>
                            </button>
                        </div>
                    </div>

                        
                    
                </div>

                <div className='p-4 h-[90vh] flex flex-col sm:items-center lg:justify-center justify-between'>
                    
                    <div>
                        {props.data.navMob.map((el, index) => (
                        <div key={index} className='text-[24px] sm:text-[48px] sm:text-center'>
                            <a href={el.link} onClick={props.onClose}>{el.text}</a>
                        </div>
                        ))}
                    </div>

                    <div className=''>
                        <div className=' mb-[20px]'>
                        {
                            props.authorized ? (
                                <div className='flex sm:hidden'>
                                    <div className="burger-menu">
                                        <a href={props.data.userAva[0].link}><img src={props.data.userAva[0].image}/></a>
                                    </div>
                                </div>
                            ) : 
                            <div className='flex sm:hidden items-center '>
                                <div className="vertical-line mx-4 h-6 bg-gray-400 hidden lg:block"></div>
        
                                <div className="flex gap-2">
                                    <a href='/login' className={`border-solid border-[1px] bg-[transparent] transition-colors duration-300 px-6 py-2 rounded-[50px]`}
                                    style={{
                                        color: props.data.colors[0].colorGray,
                                        borderColor: props.data.colors[0].colorGrey
                                        }}>
                                        {props.data.authButtons[0].text}
                                    </a>
                                    <a href='/registration' className={` transition-colors duration-300 px-6 py-2 rounded-[50px]`}
                                    style={{
                                        backgroundColor: props.data.colors[0].colorBlack,
                                        color: props.data.colors[0].colorWhite
                                    }}>
                                    {props.data.authButtons[1].text}
                                    </a>
                                </div>
                            </div>
                        }
                        </div>

                        <div className="mainBlock__top-buttons-phone flex items-center gap-6">
                            <a href="#" className={` flex items-center`}
                            style={{
                                color: props.data.colors[0].colorBlack,
                            }}>
                                <span className="redKrug"></span> {props.data.phone[0].number}
                            </a>
                            <button onClick={handleOpenModal} className={`btn  duration-300`}
                            style={{
                                backgroundColor: props.data.colors[0].colorRed,
                                color: props.data.colors[0].colorWhite
                            }}>Перезвонить</button>
                            <Modal data={props.data} isOpen={isModalOpen} onClose={handleCloseModal} />
                        </div>
                    </div>

                </div>



            </div>
        </div>
    );
};

export default SlidingMenu;
